module.exports = {
  messages: {
    PD_100_HEADING: 'XING member directory',
    PD_100_TITLE: 'Member directory',
    PD_200_NAMES_LIKE: 'Like',
    PD_CITIES_PEOPLE_BY_CITY_HEADLINE:
      'Top {count} cities, sorted by number of members ',
    PD_CITIES_PEOPLE_IN_CITIES_HEADLINE: 'Members by city',
    PD_CITIES_SEE_MORE_CITIES_LINK: 'All top cities',
    PD_CITIES_TOP_CITIES_META_DESCRIPTION:
      'XING member directory - find your business contacts from over 21 million members',
    PD_CITIES_TOP_CITIES_TITLE: 'XING member directory: Members by city | XING',
    PD_EMPTY_STATE_DESCRIPTION:
      "There aren't any members whose name starts with this letter.",
    PD_EMPTY_STATE_HEADLINE: 'All quiet around here',
    PD_EMPTY_STATE_USER_BAGS_PAGE_DESCRIPTION:
      'Try searching again with a different job title or location.',
    PD_EMPTY_STATE_USER_BAGS_PAGE_HEADLINE: 'No members matching your search',
    PD_ERROR_STATE_BUTTON_LABEL: 'Reload page',
    PD_ERROR_STATE_DESCRIPTION: 'Please try refreshing the page.',
    PD_ERROR_STATE_HEADLINE: "That didn't work.",
    PD_LOGIN_TO_SEARCH: 'Log in to search for members',
    PD_META_DESCRIPTION_LVL_0:
      'XING member directory - find new business contacts from more than 21 million members',
    PD_PEOPLE_BY_LAST_NAME_HEADLINE: 'Members by last name',
    PD_ROOT_TITLE:
      'XING member directory: Last names in alphabetical order | XING',
    PD_USER_BAG_COMPONENT_BUTTON_LABEL: 'Show more',
  },
};
